import POSConfigModule from "@/store/modules/pos-config";
import { POSConfigErrors } from "@/constants/errors/pos-config";
import BookingModule from "@/store/modules/booking";
import { getElementByQuery } from "../helpers/dom";
import { LogLevel, LogService } from "@/services/logging";
import {
  countPSSByBookingId,
  getAccountingEntiesByListOfAccountingIds_Paginated,
  getBookingInfo,
  getFullBookingById,
  getOtherTypesAccountingsByBookingId,
  getPSSBookingId,
  getTicketTypeAccountingsByBookingIdWithAccEntries_Paginated,
} from "@/api/gql/product-slot-boooking";
import NotificationService from "@/services/notification.service";
import { pullAndStorePCs } from "./product-category";
import { selectBooking, toLocalProductSlotBooking } from "./booking";
import { cloneDeep } from "lodash";
import { ISynchingReason } from "@/interfaces/store/IBooking";
import { BookingStep } from "@/constants/booking";
import CustomersModule from "@/store/modules/customers";
import { IProductCategory, PCTypes } from "@/types/db/product-category";
import { checkPromocode } from "@/api/promocodes/promocodes";
import { handleErrorAndPrepareMessage } from "../helpers/common";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import { IParsedOrder } from "@/interfaces/store/IOrder";
import OrderModule from "@/store/modules/order";
import AppModule from "@/store/modules/app";
import {
  IProductSlotState,
  IPSSExtensions,
} from "@/types/db/product-slot-state";
import { PSSErrors } from "@/constants/errors/product-slot-state";
import PSSModule from "@/store/modules/pss";
import { startTransaction } from "../helpers/fiskaly";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import dayjs from "dayjs";
import i18n from "@/lang";
// Simplified type alias to avoid TS2589 (excessively deep type instantiation)
// caused by vue-i18n v11's complex overloaded generics on t()
const t: (key: string, ...args: unknown[]) => string = (i18n.global as any).t;
import {
  editOrderExternalVoucherInfoConstruction,
  hasAppliedAndCompletedExternalVouchers,
} from "@/api/external-vouchers/incert";
import { AccountingState, PaymentMethods } from "@/types/db/accounting";
import { hasSalesStarted } from "./cash-float";
import { createOrderSession } from "../helpers/product-slot-booking";
import UserModule from "@/store/modules/user";
import AuthModule from "@/store/modules/auth";
import { IUntypedBooking, SyncStatus } from "@/types/db/product-slot-booking";
import { createCompositeId } from "../helpers/app";
import { upsertUntypedBooking } from "@/db/untyped-booking";
import { getProductCategoryById } from "@/dexie/product-category";

export function close() {
  // clear the ticket references of the applied date-of-visit filter
  // so that each time we open the orders table, we get updated results (with the recent orders)
  OrderModule.setTicketReferences([]);
  ModalModule.setStatus(ModalStatus.Hidden);
}

export function getPSCNotIncludedInConfig(pulledBooking: any) {
  const categoryIds: number[] = [];
  if (!POSConfigModule.getSelectedConfig) {
    throw new Error(POSConfigErrors.NoPOSConfigSelected);
  }
  const selectedConfigTicketGroups: number[] =
    POSConfigModule.getSelectedConfig.ticketGroups;

  const pssList = pulledBooking.pssList;
  for (let i = 0; i < pssList.length; i++) {
    const psc = pssList[i].ProductSlotCategoryRead;
    const pscTicketGroups = psc.TicketGroupTicketList.map(
      (tg: any) => tg.TicketGroupId
    );

    // This psc is not linked to any TicketGroupId
    const pscId = pssList[i].ProductSlotCategoryRead.Id;
    if (!pscTicketGroups.length) {
      categoryIds.push(pscId);
      continue;
    }

    // If at least one tgId of the PSC is included in selectedConfigTicketGroups then we don't add psc.Id to categoryIds
    const isIncluded = pscTicketGroups.some((it: any) =>
      selectedConfigTicketGroups.includes(Number(it))
    );
    if (!isIncluded) {
      categoryIds.push(pscId);
    }
  }
  return categoryIds;
}

export async function selectOrderForEditing(
  order: IParsedOrder | { id: string },
  openTeamsView?: boolean
) {
  {
    if (!hasSalesStarted.value) {
      // do not pull orders if there isn't a sales session open
      NotificationService.showCustomInfoWithTitle(
        t("common.open-sales-before-edit"),
        ""
      );
      return;
    }
    const selectedOrderId = order.id;
    // Show a spinner telling the user to wait till we pull the booking
    // TODO Hamza: now you're showing the spinner in BaseLayout.vue/el-container element and you dynamically override one element z-index,
    // what would be better is attaching the spinner here in Orders.vue with a customized text
    // Try again when you have time
    AppModule.updatedIsLoading(true);
    // Lets popup z-index to make the spinner flow over it
    const ordersOverLay = getElementByQuery(".orders > .el-overlay");
    if (ordersOverLay) {
      ordersOverLay.style.zIndex = "1999";
    }
    try {
      LogService.info(
        `Going to pull the booking with id: ${selectedOrderId} from backend`
      );
      //// Pulling large bookings logic start
      // TODO Hamza: Count PSS from remote to see if it is a large booking
      // if pssCount > 550 then we consider this booking as a large booking
      // NB: Graphql support a response of 600 nested objects

      const pssCount = await countPSSByBookingId(selectedOrderId);
      const isLargeBooking = pssCount && pssCount > 559 ? true : false;
      // isLargeBooking = await countPSSByBookingId(selectedOrderId) > 550;
      // countPSSByBookingId: ProductSlotStateCount(where:"(booking_id,eq,7256454)")
      let pulledBooking: any = null;
      if (isLargeBooking) {
        let booking: any = null;
        const bookingId = selectedOrderId;
        try {
          console.log("calling getBookingInfo");
          booking = await getBookingInfo(bookingId);

          try {
            console.log("calling getPSSBookingId");
            booking.pssList = await getPSSBookingId(bookingId);
          } catch (err) {
            console.log("Error when pulling large booking");
            console.log(err);
          }

          const bookingAccountings: any[] = [];
          try {
            console.log(
              "calling getTicketTypeAccountingsByBookingIdWithAccEntries_Paginated"
            );
            // lets concat the result of the below call to the bookingAccountings
            bookingAccountings.push(
              ...((await getTicketTypeAccountingsByBookingIdWithAccEntries_Paginated(
                bookingId
              )) || [])
            );
          } catch (err) {
            console.log("Error when pulling paginated TICKET type acountings");
            console.log(err);
          }
          try {
            console.log("calling getOtherTypesAccountingsByBookingId");
            // lets concat the result of the below call to the bookingAccountings
            bookingAccountings.push(
              ...((await getOtherTypesAccountingsByBookingId(bookingId)) || [])
            );
          } catch (err) {
            console.log("Error when pulling other type accountings");
            console.log(err);
          }
          const accountingIds: string[] = bookingAccountings.map(
            (acc) => acc.id
          );
          const bookingAccountingsEntries: any[] = [];
          try {
            console.log(
              "calling getAccountingEntiesByListOfAccountingIds_Paginated"
            );
            // lets concat the result of the below call to the bookingAccountingsEntries
            bookingAccountingsEntries.push(
              ...((await getAccountingEntiesByListOfAccountingIds_Paginated(
                accountingIds
              )) || [])
            );
          } catch (err) {
            console.log("Error when pulling paginated accounting entries");
            console.log(err);
          }
          // Lets now fill each accounting with its accountingEntries
          for (let i = 0; i < bookingAccountings.length; i++) {
            const accounting = bookingAccountings[i];
            const accountingEntries: any[] = [];
            for (let j = 0; j < bookingAccountingsEntries.length; j++) {
              const accountingEntry = bookingAccountingsEntries[j];
              if (accountingEntry.accountingId === accounting.id) {
                accountingEntries.push(accountingEntry);
              }
            }
            bookingAccountings[i].accountingEntriesList = accountingEntries;
          }
          // Lets now assing the accountings to the booking
          booking.accountings = bookingAccountings;
          console.log("------------- large booking");
          console.log(booking);
          pulledBooking = booking;
        } catch (err) {
          console.log("Error when pulling large booking");
          console.log(err);
        }
      } else {
        pulledBooking = await getFullBookingById(selectedOrderId);
      }

      //// Pulling large bookings logic end

      LogService.info(
        `We pulled the attached booking from backend, id: ${pulledBooking?.id}`,
        {
          params: pulledBooking,
        }
      );
      // If no pulled order then show general error to the user
      if (!pulledBooking) {
        LogService.info(
          `No booking with id: ${selectedOrderId} was pulled from backend`,
          undefined,
          LogLevel.Error
        );
        NotificationService.showGeneralResponseError();
      }

      // Check if PSS is linked to PSC that is not linked to the selected Config ticketGroups
      const categoryIds: number[] = getPSCNotIncludedInConfig(pulledBooking);
      // categoryIds = [43924]; //Snack 1, just to test
      if (categoryIds.length) {
        // pull these PSC from remote and store them in indexedDB
        LogService.info(
          `Going to pull PCs with  attached ids for Edit Order since they do not exist in current config`,
          {
            params: categoryIds,
          }
        );
        const missingPCs = await pullAndStorePCs(categoryIds);
      }
      // So user has access right to this order, lets convert it into IPSB type and store it in the state
      console.log("-------- pulledBooking");
      console.log(JSON.parse(JSON.stringify(pulledBooking)));
      const convertedBooking = await toLocalProductSlotBooking(pulledBooking);
      LogService.info(
        `We converted pulled booking into IPSB format, result object attached`,
        {
          params: convertedBooking,
        }
      );
      console.log("-------- convertedBooking");
      console.log(JSON.parse(JSON.stringify(convertedBooking)));

      // Foreach seating PSS, if it is none-reccuring seating plan, then you need to pull its eventKey from childPSC.seatingParentResourceEventKey
      for (let i = 0; i < convertedBooking.pssList.length; i++) {
        const childPSC = await getProductCategoryById(
          convertedBooking.pssList[i].categoryId
        );

        if (childPSC) {
          // Lets check if this is a childPSC of a reccurring parent
          if (!childPSC.isParentReccuringSeating) {
            // so this pss is not a recurring seating plan, lets override the eventKey value of this pss
            convertedBooking.pssList[i].eventKey =
              childPSC.seatingParentResourceEventKey;
          }
        }
      }
      // End of eventKey changes

      // Lets store it in bookingModule (bookings, bookingList, bookingsSteps) and consider this booking as the selected booking
      const bookingUUID = convertedBooking.uuid as string;
      BookingModule.addBooking(convertedBooking);

      // save booking to indexedDB
      const creationTime = dayjs().toISOString();
      const untypedBooking: IUntypedBooking = {
        _id: String(convertedBooking.uuid),
        uuid: String(convertedBooking.uuid),
        creationDateTime: creationTime,
        booking: convertedBooking,
        syncStatus: SyncStatus.Synced, // as it came from backend
        attempts: 0,
      };
      await upsertUntypedBooking(untypedBooking);

      // Create an order session for the booking after inserting it in Dexie
      // This is in order to avoid it being considered an update instead of a new order session
      const orderSession = createOrderSession({
        bookingUuid: convertedBooking.uuid as string,
        currency: convertedBooking.currency,
        sellerId: UserModule.userId as number,
        sellerCogn: AuthModule.cognitoId,
      });
      orderSession.bookingId = convertedBooking.id;

      BookingModule.addOrderSessionToBooking({
        orderSession,
        bookingUuid: bookingUUID,
      });

      // select the booking
      BookingModule.selectBooking(bookingUUID);

      // If the pulled booking is of type Acompte, then we show the user the payment step (he can always go back)
      // If the pulled booking is a normal booking, then we put the user in order step
      if (openTeamsView) {
        BookingModule.setBookingStep({ bookingUUID, step: BookingStep.Teams });
      } else if (BookingModule.isAcompteBooking) {
        BookingModule.setBookingStep({
          bookingUUID,
          step: BookingStep.Payment,
        });
      } else {
        BookingModule.setBookingStep({ bookingUUID, step: BookingStep.Order });
      }

      //////////// EXTERNAL VOUCHERS LOGIC
      // If this booking has applied and confirmed external voucher then we need an async call by the library to check all info of those already applied vouchers so that we build a helper object in the state to auto apply them later in this new order session
      if (hasAppliedAndCompletedExternalVouchers(convertedBooking)) {
        await editOrderExternalVoucherInfoConstruction(convertedBooking);
      }
      ////////////

      // Now lets set the customer if we have any
      const customer = pulledBooking?.CustomerRead;
      if (convertedBooking.customerId && customer) {
        const {
          country,
          email,
          phone,
          id,
          company,
          address,
          allergies,
          language,
          firstName,
          lastName,
          title,
          zipCode,
          emailMarketingOrganiser,
          birthDate,
          city,
        } = customer;

        // Lets show the customer of this booking in the UI
        await CustomersModule.setSelectedCustomers([
          {
            fullName: firstName + " " + lastName,
            bookingUuid: bookingUUID,
            checkOrder: true,
            country: country?.name || "",
            email,
            phone,
            id,
            company,
            address,
            allergies,
            language,
            firstName,
            lastName,
            title,
            zipCode,
            emailMarketingOrganiser,
            birthDate,
            city,
          },
        ]);
      }

      // For each pss lets add its extension
      let pssExtensionsCopy = cloneDeep(PSSModule.pssExtensions);
      for (const pss of convertedBooking.pssList) {
        // lets get PC data so that we store it along with the pss in pssExtensions
        // lets not forget that donation pss don't have pc in local DB
        if (pss.type !== PCTypes.Donation) {
          const pc = await getProductCategoryById(pss.categoryId);
          if (!pc) {
            LogService.info(
              `Error PC not found in local DB after pulling the booking, pssId: ${pss.id} from backend`,
              undefined,
              LogLevel.Error
            );
            continue;
          }
          pssExtensionsCopy = cloneDeep(
            addPSSExtensions({
              pssExtensions: pssExtensionsCopy,
              dt: [{ psc: pc, pss }],
            })
          );
        } else {
          // We are in a donation pss case
          // we know we don't have its PC in localDB
          pssExtensionsCopy = cloneDeep(
            addPSSExtensions({
              pssExtensions: pssExtensionsCopy,
              dt: [{ psc: null, pss }],
            })
          );
        }
      }

      PSSModule.setPSSExtensions(pssExtensionsCopy);

      // start a new transaction
      await startTransaction(bookingUUID);

      // if promocode accounting then we do check-promocode to get the promocode data
      // const accountings = convertedBooking.accountings || [];
      // let code = "";
      // for (let i = 0; i < accountings.length; i++) {
      //   if (accountings[i].promoCodeId && accountings[i].promocode) {
      //     code = accountings[i].promocode || "";
      //     break;
      //   }
      // }
      // if (code) {
      //   try {
      //     const pricesIds =
      //       [
      //         ...new Set(
      //           BookingModule.selectedBooking?.pssList.map((pss) => pss.priceId)
      //         ),
      //       ] || [];
      //     const response = await checkPromocode(
      //       code,
      //       pricesIds,
      //       Number(POSConfigModule.selectedConfig?.group),
      //       Number(POSConfigModule.selectedConfig?.id)
      //     );
      //     const promocodeData = response.data.promoCodeData;

      //     if (promocodeData) {
      //       promocodeData.code = code;
      //       BookingModule.addPromocode({
      //         promocode: promocodeData,
      //         bookingUuid: BookingModule.selectedBookingUUID,
      //       });
      //     }
      //   } catch (error) {
      //     LogService.info(
      //       `Error when checking promocode validity of Edit Order booking: ${BookingModule.selectedBookingUUID}, promocode: ${code},`,
      //       error,
      //       LogLevel.Error
      //     );
      //   }
      // }
    } catch (err: any) {
      const errorDetails = handleErrorAndPrepareMessage(err);
      LogService.info(
        `${errorDetails.errorType} Error when pulling booking with id: ${selectedOrderId} from backend`,
        { params: { err: err, errorDetails: errorDetails } },
        LogLevel.Error
      );
      const userMessage =
        errorDetails.errorType === "Network"
          ? errorDetails.errorMessage
          : t("error.booking-info-fetch");
      NotificationService.showCustomMessage(userMessage, "error");
    }
    close();
    AppModule.updatedIsLoading(false);

    // if it's an old booking (latest endDateTime is older than one day) edited by the hermitage group, we warn the user about it
    const groupId = POSConfigModule.groupId;
    if (
      groupId &&
      [1, 16342 /*TEST*/, 16383 /*DEV*/, 19329 /*Hermitage*/].includes(groupId)
    ) {
      let isOldBooking = true;
      // if a booking has only retail products, there's no need to show the warning
      let hasOnlyRetail = true;
      const selectedBooking = cloneDeep(BookingModule.selectedBooking);
      if (!selectedBooking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }
      for (const pss of selectedBooking.pssList) {
        if (pss.type !== PCTypes.Retail) {
          hasOnlyRetail = false;
        }
        if (
          pss.timeSlotId &&
          pss.endDateTime &&
          dayjs(pss.endDateTime).isSameOrAfter(dayjs(), "day")
        ) {
          // there is at least one ticket with an endDateTime not older than one day, not an old booking
          isOldBooking = false;
          break;
        }
      }
      if (!hasOnlyRetail && isOldBooking) {
        LogService.info("User is editing an old booking");
        NotificationService.showCustomMessageWithTitle(
          t("warning.old-booking"),
          t("common.warning"),
          "warning"
        );
      }
    }
  }
}

export function addPSSExtensions(data: {
  pssExtensions: IPSSExtensions;
  dt: {
    psc: IProductCategory | null;
    pss: IProductSlotState;
    sameStockPCs?: number[];
  }[];
}) {
  for (const d of data.dt) {
    const { psc, pss } = d;
    const uuid = pss.uuid as string;
    if (!uuid) {
      throw new Error(PSSErrors.HasNoUUID);
    }
    if (psc) {
      const price = psc.prices.find((price) => price.id === pss.priceId);
      const taxes = price && price.taxes ? price.taxes : [];

      data.pssExtensions[uuid] = {
        tickerGroups: psc.ticketGroups,
        taxes: taxes,
        sameStockPCs:
          d.sameStockPCs && d.sameStockPCs.length ? d.sameStockPCs : [],
      };
    } else {
      // In case the pss is actually a donation coming from backend we don't have its psc supplied
      // e.g: Locarno
      data.pssExtensions[uuid] = {
        tickerGroups: [],
        taxes: [],
        sameStockPCs: [],
      };
    }
  }

  return data.pssExtensions;
}

/**
 * Open an order. If the booking is already loaded in BookingModule (cached on
 * a separate tab), surface that booking and close the orders modal; otherwise
 * hand off to the standard editing flow which loads the iframe view.
 *
 * @param {IParsedOrder} row - The clicked row from the orders search table.
 * @returns {boolean} Sentinel — short-circuits when the cached path is taken.
 */
export function orderClick(row: IParsedOrder): boolean {
  const cached = BookingModule.bookingList.find(
    (b) => b.reference === row.reference
  );

  if (cached) {
    selectBooking(cached.uuid, { fromMoreOrders: true });
    BookingModule.setTabAnimation(true);
    close();

    return true;
  }

  selectOrderForEditing(row);

  return true;
}
